import { UserList } from '../../../components/User';
import { UserType } from '../../../types';

export function InternalUsers() {
  return <UserList type={UserType.Internal} />;
}
